import FollowersByType from "./followers-by-type";

export default FollowersByType;